<template>
  <div>
    <vx-card title="" :is-filter="true" :has-quick-search="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadMemberData(1, null, true)">

      <template slot="actions">
        <vx-input-group >
          <vs-input :placeholder="$t('search_company_name_phone_number')" class="quick-search" v-model="memberSearchParams.quickSearch"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-search"  @click="loadMemberData(1, null, true)"></vs-button>
            </div>
          </template>
        </vx-input-group>&nbsp;

        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download"  @click="exportData">{{ $t('export') }}</vs-button>&nbsp;
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"  @click="openAddMemberPopup">{{ $t('add_member') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="memberSearchParams.from" :model="memberSearchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="memberSearchParams.to" :model="memberSearchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
<!--          <v-select :options="clientGroupOptions" :reduce="label => label.value" :placeholder="$t('groups')" v-model="memberSearchParams.group" class="mb-3" />-->
          <select v-model="memberSearchParams.group" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('groups') }}</option>
            <option v-for="(option, key) in clientGroupOptions" :key="'groups_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
<!--          <v-select :options="clientLevelOptions" :reduce="label => label.value" :placeholder="$t('levels')" v-model="memberSearchParams.level" class="mb-3" />-->
          <select v-model="memberSearchParams.level" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('levels') }}</option>
            <option v-for="(option, key) in clientLevelOptions" :key="'levels_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full mb-3" v-for="(customField, key) in customFields" v-bind:key="'memberCustomField_' + key">
          <vs-input :placeholder="customField.name" v-model="memberSearchParams.customFields[customField.id]" class="w-full"/>
        </div>

      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadMemberData(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="memberDataContainer" :title="$t('members')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-member-tab-nav></shared-member-tab-nav>
      </template>

      <shared-member-list
        :members="members"
        :customFields="customFields"
        :activeColumns="activeColumns"
        @callerCompanyPopup="callerCompanyPopup"
        @openOutboundPopup="openOutboundPopup"
        @deleteMember="deleteMember"
      ></shared-member-list>

      <template slot="footer">
        <paginate
          :total="memberPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadMemberData"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal title="" id="callerCompanyModal" :active.sync="modals.viewCallerCompany" size="xl">
      <shared-view-consultation-by-company-name></shared-view-consultation-by-company-name>
    </modal>

    <modal title="" id="outboundConsultation" :active.sync="modals.outbound" size="xl">
      <shared-outbound-consultation @outboundConsultationSuccess="outboundConsultationSuccess" @saveOutboundPopup="saveOutboundPopup"></shared-outbound-consultation>
    </modal>

    <modal :title="$t('add_member')" id="addMember" size="lg" :active.sync="modals.addMember">
      <shared-add-member
        :client-group-options="clientGroupOptions"
        :client-level-options="clientLevelOptions"
        :custom-fields="customFields"
        @storeMemberSuccess="storeMemberSuccess">
      </shared-add-member>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="addMemberButton" color="primary" type="filled" @click="addMember">{{ $t('enrollment') }}</vs-button>
      </div>
    </modal>


  </div>
</template>

<script>
import SharedMemberTabNav from '@/views/Shared/Members/TabNav'
import Member from '@/models/Member'
import SharedMemberList from '@/views/Shared/Members/List'
import Paginate from '@/mixins/paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedViewConsultationByCompanyName from '@/views/Shared/Consultations/Company/List'
import SharedOutboundConsultation from '@/views/Shared/Consultations/Outbound'
import SharedAddMember from '@/views/Shared/Members/Add'
import DatePicker from '@/components/form-inputs/DatePicker'

export default {
  name: 'User.Members',
  mixins: [Paginate],
  components: {
    SharedMemberTabNav,
    SharedMemberList,
    Modal,
    SharedViewConsultationByCompanyName,
    SharedOutboundConsultation,
    SharedAddMember,
    DatePicker
  },
  data () {
    return {
      activeColumns: {},
      members: {},
      memberPages: 1,
      customFields: [],
      clientGroupOptions: [],
      clientLevelOptions: [],
      itemPerPage: null,
      memberSearchParams: {
        page: typeof this.$route.query.page !== 'undefined' ? this.$route.query.page : 1,
        quickSearch: typeof this.$route.query.quickSearch !== 'undefined' ? this.$route.query.quickSearch : '',
        group: typeof this.$route.query.group !== 'undefined' ? this.$route.query.group : '',
        level: typeof this.$route.query.level !== 'undefined' ? this.$route.query.level : '',
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : '',
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : '',
        customFields: {}
      },
      memberExportParams: {},
      companyId: this.$store.getters.userInfo.company.id,
      modals: {
        viewCallerCompany: false,
        outbound: false,
        addMember: false
      }

    }
  },
  mounted () {
    this.loadMemberData(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_consultation_callback_member_table', this.reloadMemberData)
  },
  methods: {
    reloadMemberData () {
      this.loadMemberData(this.memberSearchParams.page, null)
    },
    async loadMemberData (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#memberDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const searchParams = {}
      this.memberSearchParams.page = page

      for (const memberSearchParam in this.memberSearchParams) {
        if (memberSearchParam === 'customFields') {
          for (const memberCustomFieldId in this.memberSearchParams.customFields) {
            searchParams[`member_custom_field_${memberCustomFieldId}`] = this.memberSearchParams.customFields[memberCustomFieldId]
          }
        } else {
          searchParams[memberSearchParam] = this.memberSearchParams[memberSearchParam]
        }
      }
      if (itemPerPage === null) {
        if (this.itemPerPage !== null) {
          searchParams['itemPerPage'] = this.itemPerPage
        }
      } else {
        this.itemPerPage = itemPerPage
        searchParams['itemPerPage'] = this.itemPerPage
      }
      this.$router.replace({ query: searchParams })
      const response = await Member.all(searchParams)
      this.customFields = response.data.meta.customFields
      this.members = response.data.data.members
      this.memberPages = response.data.meta.pagination.last_page
      this.clientGroupOptions = response.data.meta.options.groups
      this.clientLevelOptions = response.data.meta.options.levels
      this.activeColumns = response.data.meta.activeColumns
      this.memberExportParams = searchParams
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#memberDataContainer > .con-vs-loading')
    },
    async deleteMember (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Member.delete(id)
        this.loadMemberData(this.initialPage)
      }
    },
    callerCompanyModal (companyName) {
      EventBus.$emit('loadConsultationByCompanyName', companyName)
      this.modals.viewCallerCompany = true
    },
    callerCompanyPopup (companyName) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-company-list', { company_name: companyName }, this.callerCompanyModal)
    },
    outboundConsultationModal (data) {
      EventBus.$emit('initResetOutboundConsultationFormData')
      EventBus.$emit('initLoadOutboundConsultation', { member_id: data.id, callback_id: data.callback_id })
      this.modals.outbound = true
    },
    openOutboundPopup (memberId) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound', { id: memberId }, this.outboundConsultationModal)
    },
    outboundConsultationSuccess (response) {
      this.$swalHelper.success({
        title: this.$t('action_success'),
        text: this.$t(response.data),
        confirmButton: this.$t('confirm')
      })
      this.modals.outbound = false
      this.loadMemberData(this.initialPage)
    },
    saveOutboundPopup () {
      EventBus.$emit('initSaveOutboundConsultationFormData')
    },
    async exportData (e) {
      e.preventDefault()
      try {
        const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        const role = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.role : ''
        await Member.export({...this.memberExportParams, companyId: this.companyId, language, role})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    addMemberModal () {
      EventBus.$emit('initAddMemberFormData')
      this.modals.addMember = true
    },
    openAddMemberPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-member', {}, this.addMemberModal)
    },
    async addMember () {
      EventBus.$emit('storeMember')
    },
    storeMemberSuccess () {
      this.loadMemberData(this.initialPage)
      this.modals.addMember = false
    }
  }
}
</script>

<style scoped>
.quick-search {
  min-width: 300px;
}
</style>
